import React from "react";
import * as cls from "./learningPlan.module.scss";
import Day from "../../resources/icons/Day";
function LearningHeader({
  isShowCurrDate,
  days,
  tableHeight,
  date,
  dayToPercentage,
}) {
  const today = new Date();
  let datePosition = (today - date) / (1000 * 60 * 60 * 24);
  datePosition = (datePosition / days) * 100;
  const getMonthName = (dateString) => {
    const date = new Date(dateString);
    let monthName = date
      .toLocaleString("default", { month: "long" })
      .slice(0, 3);
    let firstChar = monthName[0].toUpperCase();
    return firstChar + monthName.slice(1, 3);
  };

  if (date.getMonth() === new Date().getMonth() && isShowCurrDate) {
    return (
      <>
        <div
          key={date.toISOString()}
          className={cls.table_th}
          style={{
            flexBasis: `${dayToPercentage(days)}%`,
          }}
        >
          <div
            className={cls.dayIconContainer}
            style={{
              left: datePosition + "%",
              marginLeft: -40,
              display: "flex",
              justifyContent: "center",
              width: 80,
              pointerEvents: "none",
            }}
          >
            <Day height={tableHeight} />
            <div style={{ position: "absolute", top: "14px" }}>
              <div
                style={{
                  height: tableHeight - 10,
                  borderRight: "2px solid rgba(85, 140, 235, 1)",
                }}
              ></div>
            </div>
          </div>
          {getMonthName(date)}
        </div>
        <div className={cls.dashedLineHeader}></div>
      </>
    );
  }
  return (
    <>
      <div
        key={date.toISOString()}
        className={cls.table_th}
        style={{ flexBasis: `${dayToPercentage(days)}%` }}
      >
        {getMonthName(date)}
      </div>
      <div style={{ position: "relative" }}>
        <div
          className={cls.dashedLine}
          style={{
            height: `calc(${tableHeight}px - 1px)`,
          }}
        ></div>
      </div>
      <div className={cls.dashedLineHeader}></div>
    </>
  );
}

export default LearningHeader;
